// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zf3xe","newExpiryDate":"styles_newExpiryDate__3d2Pf","footer":"styles_footer__16Ibh"};